import { NgModule } from '@angular/core';
import { IsNullOrEqualsPipe } from "libraries/pipes/is-null-or-equals/is-null-or-equals.pipe";

@NgModule({
    declarations: [ IsNullOrEqualsPipe ],
    exports: [ IsNullOrEqualsPipe ],
    providers: [ IsNullOrEqualsPipe ]
})
export class IsNullOrEqualsPipeModule {  }
